/**
 * Core: Canvas functions
 * -----------------------------------------------------------------------------
 * Functions used when setting up Canvas and storybook.
 *
 */
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import { getGlobalComponents } from '~/core/canvas-imports';
import ComponentStates from '~/core/plugins/component-states';
import Helpers from '~/core/plugins/helpers';
import SectionEvents from '~/core/plugins/section-events';

/**
 * Set global components, used in Storybook.
 * @param {Object} app - Vue app object.
 */
export function setGlobalComponents(app) {
  const globalComponents = getGlobalComponents();

  Object.entries(globalComponents).forEach(([componentName, component]) => {
    app.component(componentName, component.default || component);
  });
}

/**
 * Set Canvas Vue global components and plugins.
 * @param {Object} app - Vue app object.
 */
export function setVuePlugins(app) {
  const pinia = createPinia();
  if (!cnvs.settings.disableVuexPersist) {
    pinia.use(piniaPluginPersistedstate);
  }

  app.use(pinia);

  app.use(ComponentStates);
  app.use(Helpers);

  if (!cnvs.storybook) {
    app.use(SectionEvents);
  }
}
